<div
  class="footer-container fixed bottom-0 left-0 right-0 flex items-center justify-between bg-ui-bg py-sm px-2xl {{
    extraClass
  }}"
>
  <div class="flex-1">
    <ng-content></ng-content>
  </div>
  <div class="flex items-center gap-base lg:gap-2xl">
    @if (showDownloadButton) {
      <div
        class="flex items-center cursor-pointer gap-sm"
        (click)="!isLoading ? exportBtnClicked.emit() : undefined"
      >
        <div class="flex text-primary">
          @if (!isLoading) {
            <svg-icon class="!text-sm" key="export"></svg-icon>
          }
        </div>
        @if (isLoading) {
          <mg-loading-spinner></mg-loading-spinner>
        }
        <div
          [ngClass]="{ '!block': !showNumberOfRows }"
          class="hidden lg:block text-primary text-sm leading-sm"
        >
          {{ exportTitle }}
        </div>
      </div>
    }
    @if (showNumberOfRows) {
      <div class="text-txt-secondary text-sm leading-sm">{{ numberOfRows }} rows</div>
    }
  </div>
</div>
